import { useParams } from 'react-router-dom';

import BtnGitHub from './../components/btnGitHub/BtnGitHub';
import { projects } from './../helpers/projectsList';
import BtnView from '../components/btnView/BtnView';

function ProjectPage() {
  const { id } = useParams();
  const project = projects[id];
  console.log(project);

  return (
    <main className="section">
      <div className="container">
        <div className="project-details">
          <h1 className="title-1"> {project.title} </h1>

          <img src={project.imgBig} alt={project.title} className="project-details__cover" />
          <div className="project-details__desc">
            <p>{project.skills}</p>
            <p className="project-details__description">{project.description}</p>
          </div>
          {project.link && <BtnView link={project.link} />}
          {project.gitHubLink && <BtnGitHub link={project.gitHubLink} />}
        </div>
      </div>
    </main>
  );
}

export default ProjectPage;
